import { SortTableFunctionProps } from "@src/types";

export const getSortStates = ({ ev, tableDef, singleSelect }: any) => {
  const { columnIndex, sortOrder } = ev.detail;
  const newColumnIndex = singleSelect ? columnIndex - 1 : columnIndex;
  let pIndex = null;
  ev.target.classList.forEach((entry: string) => {
    if (entry.includes("parent-data-index")) {
      pIndex = Number(entry.split("-").pop());
    }
  });

  const sortKeys = tableDef
    ? tableDef.columns.map((col: any) =>
        col.children
          ? col.children
              .map((ccol: any) => ccol.sortable && ccol.dataKey)
              .flat()
          : col.sortable && col.dataKey
      )
    : [];

  if (!isNaN(newColumnIndex) && sortOrder) {
    return {
      sortOrder: sortOrder,
      sort:
        pIndex !== null
          ? sortKeys[pIndex][newColumnIndex]
          : sortKeys[newColumnIndex],
      pIndex,
    };
  }
  return {
    sortOrder: "",
    sort: "",
    pIndex,
  };
};

export const sortTableData = ({
  data,
  currentSort,
  currentPage,
  rowsPerPage,
}: SortTableFunctionProps) => {
  const sortedElements = currentSort.sort
    ? [...data]?.sort((a, b) => {
        const key = currentSort.sort;
        const val1: string = (currentSort.sortOrder === "asc" ? a : b)[key];
        const val2 = (currentSort.sortOrder === "asc" ? b : a)[key];
        const str1 = "" + val1 || "";
        const str2 = "" + val2 || "";
        const num1 = parseFloat(str1.replaceAll(/,/g, ""));
        const num2 = parseFloat(str2.replaceAll(/,/g, ""));
        if (!isNaN(num1) && !isNaN(num2)) {
          return num1 - num2;
        }
        return str1.localeCompare(str2);
      })
    : [...data].sort(customSort);

  const pageData = sortedElements?.slice(
    currentPage * rowsPerPage,
    currentPage * rowsPerPage + rowsPerPage
  );
  return { pageData, sortedElements };
};

const customSort = (a: any, b: any) => {
  if (
    a.transcript_accession.startsWith("NM") &&
    b.transcript_accession.startsWith("NM")
  ) {
    if (a.transcript_status < b.transcript_status) return 1;
    if (a.transcript_status > b.transcript_status) return -1;
    return 0;
  } else {
    if (a.transcript_accession < b.transcript_accession) return -1;
    if (a.transcript_accession > b.transcript_accession) return 1;
    return 0;
  }
};
